<div class="row mb-3">
    <div class="col-12 col-md-4 col-xl-3">
        <div class="d-flex align-items-center">
            <span class="me-3">Modo de visualizacion</span>
            <ng-select class="flex-grow-1" [items]="subtipos" bindValue="clave" bindLabel="valor"
                [(ngModel)]="pregunta.Subtipo" [clearable]="false" [disabled]="accesoPublico"></ng-select>
        </div>
    </div>
</div>
<div class="row" *ngFor="let item of items; index as i">
    <div class="col">
        <div class="container-fluid">
            <div class="row">
                <div class="col d-flex align-items-center mb-1">
                    <app-svg-icon *ngIf="item.Checkpoint" [size]="16" icon="patch-check-fill"
                        class="text-primary me-1"></app-svg-icon>
                    <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                        [attr.item-id]="!accesoPublico ? item.Id : null" container="body"
                        ngbTooltip="{{!accesoPublico ? item.Id : null}}">
                        {{ item.IdRelativo }}
                    </h3>
                    <input type="text" class="form-control white-borders"
                        [(ngModel)]="item.Texto" [disabled]="accesoPublico" />
                </div>
                <div class="col flex-grow-0 text-end my-auto d-flex" *ngIf="pregunta.SiguientePregunta != null &&
                    item.PreguntaSiguiente !== pregunta.SiguientePregunta && !esMultiple">
                    <app-svg-icon icon="arrow-right" class="me-1"></app-svg-icon>
                    {{ item.PreguntaSiguiente }}
                </div>
                <div class="col flex-grow-0 text-end my-auto pe-0" *ngIf="item.Condiciones">
                    <app-svg-icon class="me-2" icon="eye" [size]="20" (click)="abrirEditorCondiciones(item)">
                    </app-svg-icon>
                </div>
                <div class="col flex-grow-0 text-end my-auto pe-0" *ngIf="item.EsOpcionKiller || item.Alineacion != null">
                    <h4 class="mb-0" *ngIf="item.EsOpcionKiller">(K)</h4>
                    <h4 class="mb-0" *ngIf="item.Alineacion != null">({{item.Alineacion}})</h4>
                </div>
                <div class="col flex-grow-0 text-end my-auto">
                    <div ngbDropdown class="d-inline-block" container="body" *ngIf="!accesoPublico">
                        <app-svg-icon ngbDropdownToggle class="dropdown-sin-flecha" [size]="24"
                            icon="three-dots-vertical"></app-svg-icon>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem [command]="borrarCmd" [commandArg]="item">Borrar</button>
                            <button ngbDropdownItem (click)="abrirEditorCondiciones(item)">
                                Editor de condiciones
                            </button>
                            <button ngbDropdownItem [command]="abrirModalSiguientePreguntaCmd" [commandArg]="item">
                                Siguiente pregunta
                            </button>
                            <div ngbDropdownItem [command]="abrirAccionesCmd" [commandArg]="item">Acciones</div>
                            <div ngbDropdownItem>
                                <div class="form-check form-switch form-switch-lg">
                                    <input type="checkbox" class="form-check-input" [id]="'killer' + item.Id"
                                        [(ngModel)]="item.EsOpcionKiller">
                                    <label class="form-label form-check-label" [for]="'killer' + item.Id">
                                        Killer
                                    </label>
                                </div>
                            </div>
                            <div ngbDropdownItem>
                                <div class="form-check form-switch form-switch-lg">
                                    <input type="checkbox" class="form-check-input" [id]="'top' + item.Id"
                                        (change)="cambiarAlineacion(item, $event, 'T')"
                                        [checked]="alineacionMap.get(item.Id) === 'T'">
                                    <label class="form-label form-check-label" [for]="'top' + item.Id">
                                        Top
                                    </label>
                                </div>
                            </div>
                            <div ngbDropdownItem>
                                <div class="form-check form-switch form-switch-lg">
                                    <input type="checkbox" class="form-check-input" [id]="'bottom' + item.Id"
                                        (change)="cambiarAlineacion(item, $event, 'B')"
                                        [checked]="alineacionMap.get(item.Id) === 'B'">
                                    <label class="form-label form-check-label" [for]="'bottom' + item.Id">
                                        Bottom
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="!accesoPublico">
    <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
    <div class="col mb-3">
        <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
            [(ngModel)]="textoItem" (keyup.enter)="agregarCmd.ejecutar()" [disabled]="!agregarCmd.puedeEjecutarse" />
    </div>
</div>
